module.exports = __webpack_public_path__ + "img/abergele.ee88d448.png";